<form [formGroup]="form" #formDirective="ngForm">
  <div class="card card-body">
    <div class="row" *ngIf="!isConsulta">
      <div class="col-sm-11 col-xl-6 col-xxl-4">
        <lib-autocomplete
          #selecaoRegrasRegra
          (selectionChanged)="regraSelecionada($event)"
          [schema]="regraSchema"
        ></lib-autocomplete>
        <span class="hint" *ngIf="!associacao">
          <i class="fa fa-info-circle"></i> Regra composta: necessário duas ou mais regras simples.
        </span>
      </div>
      <div class="col-1 mt-3">
        <button
          mat-mini-fab
          color="primary"
          type="button"
          title="Adicionar"
          [disabled]="form.invalid"
          (click)="adicionarRegra()">
          <i class="fas fa-plus-circle" aria-hidden="true"></i>
        </button>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-12">
        <table class="table label-maps table-striped table-bordered table-hover table-responsive-sm">
          <thead>
            <tr>
              <th>Nome</th>
              <th class="text-center" *ngIf="!regra || !isConsulta">Ação</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let s of getRegrasPaging()">
              <td>{{ s.name || s.nome }}</td>
              <td class="pt-1 pb-1" *ngIf="!regra || !isConsulta">
                <div class="d-flex flex-row justify-content-center">
                    <button
                        mat-icon-button
                        color="warn"
                        type="button"
                        (click)="remove(s)"
                        title="Excluir"
                      >
                      <i class="fas fa-minus-circle" aria-hidden="true"></i>
                    </button>
                </div>

              </td>
            </tr>
          </tbody>
        </table>
        <div class="d-flex justify-content-center">
          <maps-pagination
            [items]="this.getRegrasTotalPage()"
            *ngIf="this.getRegrasTotalPage() && this.getRegrasTotalPage() > 0"
            (pageSend)="receiverPage($event)"
          ></maps-pagination>
        </div>
      </div>
    </div>
  </div>
</form>
